import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gpCreditFormat'
})
export class GpCreditFormatPipe implements PipeTransform {

  constructor() {}

  transform(value: number, creditpre = 4): string { return value != null ? value.toFixed(creditpre) : ''; }

}
